<template>
  <!-- Form Detail -->
  <v-flex v-if="this.item" sm12 md12 lg12 class="full-height scroll">
    <v-card light>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Assign Issue</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('on-close-click')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-form style="width:100%" ref="form" :lazy-validation="false">
            <div class="d-flex">
              <!-- Departments -->
              <div class="card flex px-2 py-1 mx-1">
                <!-- Contact -->
                <div class="header-contact">DEPARTMENTS</div>

                <!-- Department -->
                <div class="form-item-view">
                  <div class="form-item-label">Department</div>
                  <v-text-field
                    solo
                    flat
                    :disabled="true"
                    v-model="form.department_name"
                    label="Department Name"
                    hide-details
                  />
                </div>

                <!-- Complaint ID -->
                <div class="form-item-view">
                  <div class="form-item-label">Complaint ID</div>
                  <v-text-field
                    solo
                    flat
                    :type="'text'"
                    :disabled="true"
                    label="Complaint ID"
                    v-model="form.id"
                    hide-details
                  />
                </div>

                <!-- Staff List -->
                <div class="form-item-view">
                  <div class="form-item-label">Staff List</div>
                  <v-select
                    v-model="form.staff"
                    :items="staffs"
                    item-value="id"
                    item-text="name"
                    :disabled="fetchStaffsLoading"
                    :loading="fetchStaffsLoading"
                    @change="changeStaff()"
                    :rules="rules.rulesStaff"
                    clearable
                    required
                  >
                    <template v-slot:label="{ item }">
                      <div>{{ item.name }}</div>
                      <div class="caption">{{ item.address }}</div>
                    </template>
                  </v-select>
                </div>
              </div>

              <!-- Contact Person -->
              <div class="card flex px-2 py-1 mx-1">
                <!-- Contact -->
                <div class="header-contact">CONTACT PERSON DETAILS</div>
                <!-- Name -->
                <div class="form-item-view">
                  <div class="form-item-label">Name</div>
                  <v-text-field
                    solo
                    flat
                    v-model="form.name"
                    :error-messages="errors.name"
                    label="Enter Name"
                    :disabled="true"
                    hide-details
                  />
                </div>

                <!-- Email -->
                <div class="form-item-view">
                  <div class="form-item-label">Email</div>
                  <v-text-field
                    solo
                    flat
                    v-model="form.email"
                    label="Enter Email"
                    :error-messages="errors.email"
                    :disabled="true"
                    hide-details
                  />
                </div>

                <!-- Phone -->
                <div class="form-item-view">
                  <div class="form-item-label">Phone No</div>
                  <v-text-field
                    solo
                    flat
                    v-model="form.mobile"
                    :error-messages="errors.mobile"
                    :disabled="true"
                    hide-details
                  />
                </div>

                <!-- Ward -->
                <div class="form-item-view">
                  <div class="form-item-label">Ward</div>
                  <v-text-field
                    solo
                    flat
                    :value="(form.ward && form.ward.name) || 'Out of Ward'"
                    :disabled="true"
                    hide-details
                  />
                </div>

                <!-- Address -->
                <div class="form-item-view">
                  <div class="form-item-label">Address</div>
                  <v-text-field
                    solo
                    flat
                    :value="form.address"
                    :disabled="true"
                    hide-details
                  />
                </div>
              </div>
            </div>

            <!-- Complaint -->
            <div class="card px-2 py-1 mx-1 my-1">
              <div class="header-contact">Complaint details</div>

              <!-- Ward -->
              <div class="form-item-view">
                <div class="form-item-label">Ward No</div>
                <v-text-field
                  solo
                  flat
                  :value="(item.ward && item.ward.name) || 'Out of Ward'"
                  :disabled="true"
                  hide-details
                />
              </div>

              <!-- Map -->
              <Map style="height: 400px">
                <LayersControl
                  position="bottomright"
                  legends-control-position="topright"
                  :custom-overlay-layers="[
                    {
                      title: 'Wards',
                      name: 'Imc_20_wards',
                      url:
                        'https://geoserver.eofactory.ai:8443/geoserver/utility_v2/wms/reflect'
                    }
                  ]"
                />

                <ComplaintMarker :complaint="item" />
              </Map>
            </div>

            <!-- Submit -->
            <div
              class="form-item-view"
              style="display: flex; width: 100%; justify-content: flex-end"
            >
              <v-btn :loading="onSubmit" color="primary" @click="submitForm"
                >Assign</v-btn
              >
            </div>
          </v-form>
        </v-layout>
      </v-container>
    </v-card>
  </v-flex>
</template>
<script>
import api from "@/api";

import Map from "@/components/Map/Map";
import ComplaintMarker from "@/components/ComplaintMarker";
import LayersControl from "@/components/Map/modules/LayersControl/LayersControl";

export default {
  components: {
    Map,
    ComplaintMarker,
    LayersControl
  },

  props: {
    item: {
      type: Object
    }
  },

  watch: {
    item: function(val) {
      this.resetForm();
      if (val) {
        var item = val;
        if (item.assigned_to) {
          this.form.name = item.assigned_to.name;
          this.form.email = item.assigned_to.email;
          this.form.mobile = item.assigned_to.mobile;
          this.form.position = item.assigned_to.position;
          this.form.staff = item.assigned_to.id;
          this.form.address = item.assigned_to.address;
          this.form.ward = item.assigned_to.ward;
        }

        this.form.id = item.id;
        if (item.category) {
          this.form.department_name = item.category.department.name;
          this.form.department_id = item.category.department.id;
        }
        this.getDataSelect(item);
      }
    }
  },

  data() {
    return {
      onSubmit: false,
      errors: {},
      staffs: undefined,
      rules: {
        rulesStaff: [v => !!v || "Staff is required"]
      },
      form: {
        id: undefined,
        user_id: undefined,
        department_name: undefined,
        department_id: undefined,
        ward: undefined,
        name: undefined,
        password: undefined,
        password_confirmation: undefined,
        mobile: undefined,
        address: undefined,
        email: undefined,
        position: undefined
      },

      fetchStaffsLoading: false
    };
  },

  methods: {
    resetForm() {
      this.form = {
        id: undefined,
        user: undefined,
        department_name: undefined,
        department_id: undefined,
        ward: undefined,
        name: undefined,
        password: undefined,
        password_confirmation: undefined,
        mobile: undefined,
        address: undefined,
        email: undefined,
        position: undefined
      };
    },

    getDataSelect(item) {
      this.getStaffs(item);
    },

    async getStaffs(item) {
      try {
        this.fetchStaffsLoading = true;

        const res = await api.getUserByDepartment(item.category.department_id);

        this.staffs = res.data;
      } catch (error) {
        this.$notify.error(error.message);
      } finally {
        this.fetchStaffsLoading = false;
      }
    },

    async submitForm() {
      try {
        this.onSubmit = true;
        if (!(this.form.id && this.$refs.form.validate())) return;

        await api.assignComplaint(this.form.id, {
          assigned_to: this.form.staff
        });
        this.showAssignForm = false;

        this.$emit("assign");
        this.resetForm();

        this.$notify.success("Assign Success");
      } catch (error) {
        this.$notify.error(error.message);
        this.resetForm();
      } finally {
        this.onSubmit = false;
      }
    },

    changeStaff() {
      if (this.form.staff) {
        var staff = this.staffs.find(item => item.id === this.form.staff);
        this.form.name = staff.name;
        this.form.mobile = staff.mobile;
        this.form.email = staff.email;
        this.form.position = staff.position;
        this.form.adress = staff.adress;
        this.form.ward = staff.ward;
      } else {
        this.form.name = undefined;
        this.form.mobile = undefined;
        this.form.email = undefined;
        this.form.position = undefined;
        this.form.adress = undefined;
        this.form.ward = undefined;
      }
    }
  },

  mounted() {}
};
</script>

<style lang="css" scoped>
.full-height {
  flex: 1 1 auto;
  min-height: 0;
}
.scroll {
  overflow-y: auto;
}

.form-item-view {
  display: flex;
  width: 100%;
  align-items: center;
}

.form-item-label {
  width: 10em;
  text-align: right;
  margin-right: 1.25em;
  font-weight: 600;
}

.header-contact {
  font-size: 1.25em;
  margin-bottom: 0.625em;
  text-transform: uppercase;
}
</style>
